<template>
<header class="app-header">
    <div class="logo-content">
        <img src="@/assets/img/header-logo.png" alt="" class="logo-img" @click="handleCollapse">
    </div>
    <div class="header-content">
        <div class="header-item">
            <el-button class="lang-switch" type="text" @click="handleLangSwitch">
                <i class="icon" :class="$i18n.locale=='zh' ? 'i-zh_to_en' : 'i-en_to_zh'"/>
            </el-button>
        </div>
        <div class="user-info">
            <img class="user-avatar" v-if="user.avatar" :src="user.avatarr">
            <img class="user-avatar" v-else src="@/assets/img/defult-avatar.png">
            <el-dropdown trigger="click" class="app-header-dropdown">
                <span>
                    <span class="user-name">{{user.name || user.username}}</span>
                    <span class="arrow-down"></span>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item class="app-header-dropdown-item">
                        <span class="handleLogout" type="text" size="mini" @click="handleLogout">{{$t(/*登出*/'c.logout')}}</span>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</header>
</template>

<script>
import Core from "../../../core";

export default {
    name: "AppHeader",
    props: {},
    watch: {},
    data() {
        return {
            user: Core.Data.getUser()
        };
    },
    mounted() {
        console.log('this.$i18n.locale:', this.$i18n.locale)
        console.log('this.$i18n:', this.$i18n)
    },
    methods: {
        handleCollapse() {
            this.$emit('collapse')
        },
        handleLogout() {
            this.$confirm(this.$t(/*确定要登出系统吗？*/'tip.ask_logout'), this.$t(/*提示*/'c.tip'), {
                confirmButtonText: this.$t(/*确定*/'c.confirm'),
                cancelButtonText: this.$t(/*取消*/'c.cancel'),
                type: "warning"
            }).then(() => {
                Core.Data.clearUserData();
                this.$router.push({path: "/login"});
                this.$message.success(this.$t(/*操作成功*/'c.oper_success'));
            });
        },

        // 中英文切换
        handleLangSwitch() {
            console.log('handleLangSwitch', this.$i18n)
            this.$i18n.locale = this.$i18n.locale === 'zh' ? 'en' : 'zh'
            Core.Data.setLanguage(this.$i18n.locale)
        },
    }
};
</script>

<style scoped lang="scss">
.app-header {
    height: 50px;
    background: #FFFFFF;
    border-bottom: 1px solid rgba(82, 91, 104, 0.2);
    display: flex;
    box-sizing: border-box;
    .logo-content {
        width: 200px;
        @include fcc();
        .logo-img {
            height: 25px;
        }
    }
    .header-content {
        width: calc(100% - 200px);
        @include fac(flex-end);
        .header-item {
            height: 100%;
            width: 50px;
            @include fac();
        }
    }
    .lang-switch {
        color: #34383E;
        &:hover { color: #155BD4; }
        .icon {
            font-size: 20px;
        }
    }
    .user-info {
        display: flex;
        justify-content: flex-end;
        padding-right: 20px;
        height: 50px;
        align-items: center;
        .user-avatar {
            width: 30px;
            height: 30px;
            margin-right: 10px;
        }
        .user-name {
            margin-right: 6px;
            font-size: 14px;
            color: #34383E;
            vertical-align: middle;
        }
        .arrow-down {
            vertical-align: middle;
            height: 6px;
            width: 6px;
            display: inline-block;
            transform: rotate(45deg);
            border-right: 1px solid #838E9B;
            border-bottom: 1px solid #838E9B;
        }
    }
}
.app-header-dropdown {
    cursor: pointer;
}
</style>
